import { render } from "./SaleAdd.vue?vue&type=template&id=4ffbf5ca&scoped=true"
import script from "./SaleAdd.vue?vue&type=script&lang=js"
export * from "./SaleAdd.vue?vue&type=script&lang=js"

import "./SaleAdd.vue?vue&type=style&index=0&id=4ffbf5ca&scoped=true&lang=css"
import "./SaleAdd.vue?vue&type=style&index=1&id=4ffbf5ca&lang=css"

import exportComponent from "D:\\laragon\\www\\subeasy\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ffbf5ca"]])

export default __exports__